import styled from 'styled-components';
import { ButtonConfirm } from '../../../components/ButtonConfirm';
import { ButtonOptions } from '../../../components/ButtonOptions';
import { TextInfo } from '../../../components/TextInfo';
import { colors } from '../../../styles/tokens';

export const Container = styled.div`
  width: 100%;
  min-width: 750px;

  background-color: ${colors.surfaceContainerLow};
  padding-bottom: 10px;

  min-height: 500px;
  max-height: 650px;

  @media (max-width: 1199px) {
    min-width: auto;
  }

  overflow-y: scroll;
`;

export const Content = styled.div`
  width: calc(100% - 40px);
  margin: auto;
`;

export const Title = styled.h2`
  font-size: 20px;
  margin: 15px 0;
  font-weight: 700;
  color: ${colors.onSurface};
`;

export const ContainerInfo = styled.div`
  margin: 15px 0;
`;

export const Info = styled(TextInfo)`
  span {
    font-size: 13px;
  }
`;

export const SectionQr = styled.div`
  padding-bottom: 10px;

  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  @media (max-width: 1199px) {
    flex-direction: column;
  }
`;

export const ContainerQrCodeImage = styled.div`
  width: 250px;
  height: 250px;

  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  margin-left: 20px;

  img {
    max-height: 100%;
    width: auto;
  }
`;

export const Instructions = styled.div`
  h3 {
    font-weight: 700;
    font-size: 14px;
    color: ${colors.onSurface};
    margin-bottom: 12px;
  }

  p {
    font-weight: 400;
    font-size: 13px;
    color: ${colors.onSurfaceVariant};
    margin-bottom: 6px;
  }
`;

export const SectionCopyPast = styled.div`
  padding-bottom: 15px;

  border-bottom: 1px solid ${colors.outlineVariant};
`;

export const KeyCopyPast = styled.div`
  margin: 10px 0;
  background-color: ${colors.surfaceContainerHigh};
  border-radius: 10px;
  padding: 10px 5px;
  word-break: break-all;
`;

export const ButtonCopy = styled(ButtonOptions)``;

export const ContainerBill = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;

  padding: 10px 0;
`;

export const LineBill = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 18px;

  & span:last-child {
    text-align: right;
    color: ${colors.onSurfaceVariant};
  }

  @media (max-width: 1199px) {
    span {
      font-size: 16px;
    }
  }
`;

export const ButtonFinish = styled(ButtonConfirm)`
  margin: 20px auto;
`;
